import {
    UPDATE_QUIZ,
    GET_QUIZ_REQUEST, GET_QUIZ_SUCCESS, GET_QUIZ_FAIL,
    GET_ALL_QUIZZES_REQUEST, GET_ALL_QUIZZES_SUCCESS, GET_ALL_QUIZZES_FAIL,
    GET_QUIZZES_BY_MODULE_REQUEST, GET_QUIZZES_BY_MODULE_SUCCESS, GET_QUIZZES_BY_MODULE_FAIL,
    GET_QUIZZES_BY_TYPE_REQUEST, GET_QUIZZES_BY_TYPE_SUCCESS, GET_QUIZZES_BY_TYPE_FAIL,
    CREATE_QUIZ_REQUEST, CREATE_QUIZ_SUCCESS, CREATE_QUIZ_FAIL,
    UPDATE_QUIZ_REQUEST, UPDATE_QUIZ_SUCCESS, UPDATE_QUIZ_FAIL,
    DELETE_QUIZ_REQUEST, DELETE_QUIZ_SUCCESS, DELETE_QUIZ_FAIL,
    GET_QUESTIONS_BY_QUIZ_REQUEST, GET_QUESTIONS_BY_QUIZ_SUCCESS, GET_QUESTIONS_BY_QUIZ_FAIL,
    CREATE_QUESTION_REQUEST, CREATE_QUESTION_SUCCESS, CREATE_QUESTION_FAIL,
    UPDATE_QUESTION_REQUEST, UPDATE_QUESTION_SUCCESS, UPDATE_QUESTION_FAIL,
    DELETE_QUESTION_REQUEST, DELETE_QUESTION_SUCCESS, DELETE_QUESTION_FAIL,
    SET_QUIZ_LOADING,
    CLEAR_QUIZ_MESSAGE,
    START_QUIZ_ATTEMPT_REQUEST, START_QUIZ_ATTEMPT_SUCCESS, START_QUIZ_ATTEMPT_FAIL,
    SUBMIT_QUIZ_ATTEMPT_REQUEST, SUBMIT_QUIZ_ATTEMPT_SUCCESS, SUBMIT_QUIZ_ATTEMPT_FAIL,
    GET_QUIZ_ATTEMPT_REQUEST, GET_QUIZ_ATTEMPT_SUCCESS, GET_QUIZ_ATTEMPT_FAIL,
    GET_ATTEMPTS_BY_COLLABORATEUR_REQUEST, GET_ATTEMPTS_BY_COLLABORATEUR_SUCCESS, GET_ATTEMPTS_BY_COLLABORATEUR_FAIL,
    CLEAR_QUIZ_PLAYER_STATE
} from '../actions/quizActions';

const initialState = {
    quizzes: [],
    currentQuiz: null,
    questions: [],
    loading: false,
    message: '',
    error: null,

    // player state
    currentPassage: null,      // { tentative, quiz, questions }
    currentAttempt: null,      // tentative seulement
    attempts: [],
    submitting: false
};

function quizReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_QUIZ:
            return {
                ...state,
                currentQuiz: action.quiz
            };

        case SET_QUIZ_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case CLEAR_QUIZ_MESSAGE:
            return {
                ...state,
                message: '',
                error: null
            };

        case GET_QUIZ_REQUEST:
        case GET_ALL_QUIZZES_REQUEST:
        case GET_QUIZZES_BY_MODULE_REQUEST:
        case GET_QUIZZES_BY_TYPE_REQUEST:
        case CREATE_QUIZ_REQUEST:
        case UPDATE_QUIZ_REQUEST:
        case DELETE_QUIZ_REQUEST:
        case GET_QUESTIONS_BY_QUIZ_REQUEST:
        case CREATE_QUESTION_REQUEST:
        case UPDATE_QUESTION_REQUEST:
        case DELETE_QUESTION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_QUIZ_SUCCESS:
            return {
                ...state,
                currentQuiz: action.payload,
                loading: false,
                message: ''
            };

        case GET_ALL_QUIZZES_SUCCESS:
        case GET_QUIZZES_BY_MODULE_SUCCESS:
        case GET_QUIZZES_BY_TYPE_SUCCESS:
            return {
                ...state,
                quizzes: action.payload,
                loading: false,
                message: ''
            };

        case CREATE_QUIZ_SUCCESS:
            return {
                ...state,
                quizzes: [action.payload, ...state.quizzes],
                loading: false,
                message: 'Quiz créé avec succès'
            };

        case UPDATE_QUIZ_SUCCESS:
            return {
                ...state,
                quizzes: state.quizzes.map((quiz) =>
                    quiz.id === action.payload.id ? action.payload : quiz
                ),
                currentQuiz: state.currentQuiz?.id === action.payload.id
                    ? action.payload
                    : state.currentQuiz,
                loading: false,
                message: 'Quiz mis à jour avec succès'
            };

        case DELETE_QUIZ_SUCCESS:
            return {
                ...state,
                quizzes: state.quizzes.filter((quiz) => quiz.id !== action.payload.quizId),
                currentQuiz: state.currentQuiz?.id === action.payload.quizId ? null : state.currentQuiz,
                questions: state.currentQuiz?.id === action.payload.quizId ? [] : state.questions,
                loading: false,
                message: 'Quiz supprimé avec succès'
            };

        case GET_QUESTIONS_BY_QUIZ_SUCCESS:
            return {
                ...state,
                questions: action.payload,
                loading: false,
                message: ''
            };

        case CREATE_QUESTION_SUCCESS:
            return {
                ...state,
                questions: [...state.questions, action.payload].sort((a, b) => (a.ordre || 0) - (b.ordre || 0)),
                loading: false,
                message: 'Question créée avec succès'
            };

        case UPDATE_QUESTION_SUCCESS:
            return {
                ...state,
                questions: state.questions
                    .map((question) => question.id === action.payload.id ? action.payload : question)
                    .sort((a, b) => (a.ordre || 0) - (b.ordre || 0)),
                loading: false,
                message: 'Question mise à jour avec succès'
            };

        case DELETE_QUESTION_SUCCESS:
            return {
                ...state,
                questions: state.questions.filter((question) => question.id !== action.payload.questionId),
                loading: false,
                message: 'Question supprimée avec succès'
            };

        case GET_QUIZ_FAIL:
        case GET_ALL_QUIZZES_FAIL:
        case GET_QUIZZES_BY_MODULE_FAIL:
        case GET_QUIZZES_BY_TYPE_FAIL:
        case CREATE_QUIZ_FAIL:
        case UPDATE_QUIZ_FAIL:
        case DELETE_QUIZ_FAIL:
        case GET_QUESTIONS_BY_QUIZ_FAIL:
        case CREATE_QUESTION_FAIL:
        case UPDATE_QUESTION_FAIL:
        case DELETE_QUESTION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case CLEAR_QUIZ_PLAYER_STATE:
            return {
                ...state,
                currentPassage: null,
                currentAttempt: null,
                attempts: [],
                submitting: false,
                error: null
            };

        case START_QUIZ_ATTEMPT_REQUEST:
        case GET_QUIZ_ATTEMPT_REQUEST:
        case GET_ATTEMPTS_BY_COLLABORATEUR_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case SUBMIT_QUIZ_ATTEMPT_REQUEST:
            return {
                ...state,
                submitting: true,
                error: null
            };

        case START_QUIZ_ATTEMPT_SUCCESS:
            return {
                ...state,
                loading: false,
                currentPassage: action.payload,
                currentAttempt: action.payload?.tentative || null,
                message: ''
            };

        case GET_QUIZ_ATTEMPT_SUCCESS:
            return {
                ...state,
                loading: false,
                currentAttempt: action.payload,
                message: ''
            };

        case GET_ATTEMPTS_BY_COLLABORATEUR_SUCCESS:
            return {
                ...state,
                loading: false,
                attempts: action.payload || [],
                message: ''
            };

        case SUBMIT_QUIZ_ATTEMPT_SUCCESS:
            return {
                ...state,
                submitting: false,
                currentAttempt: action.payload,
                message: 'Quiz soumis avec succès'
            };

        case START_QUIZ_ATTEMPT_FAIL:
        case GET_QUIZ_ATTEMPT_FAIL:
        case GET_ATTEMPTS_BY_COLLABORATEUR_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case SUBMIT_QUIZ_ATTEMPT_FAIL:
            return {
                ...state,
                submitting: false,
                error: action.error
            };

        default:
            return state;
    }
}

export default quizReducer;